import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class URLService {
  private sharedURL: string;

  setSharedURL(value: string) {
    this.sharedURL = value;
  }

  getSharedURL(): string {
    return this.sharedURL;
  }
}
